import * as Types from '../../../graphql-types'

import { gql } from '@apollo/client'
export type Common_MediaFragmentFragment = {
  __typename?: 'Media'
  mediaId?: string | null
  contentId?: string | null
  mediaMaestroTitleCode?: string | null
  policyId?: number | null
  updatedAt?: any | null
  duration?: number | null
  isPublished?: boolean | null
  mediaAssets?: Array<{
    __typename?: 'MediaAsset'
    id?: string | null
    providerKey?: string | null
  } | null> | null
}

export const Common_MediaFragmentFragmentDoc = gql`
  fragment Common_MediaFragment on Media {
    mediaId
    contentId
    mediaMaestroTitleCode
    policyId
    updatedAt
    duration
    isPublished
    mediaAssets {
      id
      providerKey
    }
  }
`
